import type { ModuleManifest } from '@confluent/shared/modules';

export const CODE_MODULE_ID = 'code';

/**
 * Code generation as a module an organization turns on (Track C, owner decision C-5).
 *
 * It is not an industry: any organization can build software, and the capability has a workforce, workflows and a
 * cost of its own. Turning the module on is what gives an organization the code workforce (its personas are this
 * module's building blocks, acquired with it) and opens the code side of a project; with it off, the code routes
 * answer 404 and nothing of it is seeded. Its screens are the unified project screen's code tab — it adds no pages
 * of its own, so it contributes no navigation.
 */
export const codeManifest: ModuleManifest = {
  id: CODE_MODULE_ID,
  kind: 'department',
  displayName: 'Code',
  description: 'A code workforce that designs, writes, reviews and previews software for a project',
  icon: 'Code2',
  navOrder: 20,
  status: 'active',
  policies: ['CanAccessProjectCode', 'CanManageProjectCode'],
  nav: [],
  dependsOn: ['core'],
};
